import React from 'react';
import { Dropdown } from 'semantic-ui-react';

import withPassengerOptionsQuery from './withPassengerOptionsQuery';

const PassengerDropdown = ({passengerOptions, onSearchPassengers, onPassengerSelect}) => (
  <Dropdown
    searchInput={{ autoFocus: true }}
    selection
    fluid
    search
    options={passengerOptions}
    onSearchChange={onSearchPassengers}
    onChange={onPassengerSelect}
    placeholder="Choose a passenger"
    selectOnBlur={false}
  />
);

export default withPassengerOptionsQuery(PassengerDropdown);



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Passengers/AddPassenger/PassengerDropdown.js